(function() {
    document.addEventListener('DOMContentLoaded', function() {
    
      var currentUrl = window.location.href;
      var url = new URL(currentUrl);
    
      function createURL(urlPath) {
        return `https://store.newulife.com${urlPath}`;
      }
    
      // IS THERE A WAY TO PULL THE LANGUAGES IN BY MODIFY THE SHOPIFY URL BASED ON DEFAULT LANGUAGE?
      const URLs = {
        en: createURL('/#'),
        es: createURL('/es/#'),
        zh_tw: createURL('/zh-TW/#'),
        zh: createURL('/zh/#'),
        ja: createURL('/ja/#'),
        ko: createURL('/ko/#'),
        th: createURL('/th/#'),
      };
    
      const shopifyURLs = {
        en: '/en',
        'zh-CN': '/zh-hans',
        'zh-TW': '/zh-hant',
        es: '/es',
        ja: '/ja',
        th: '/th',
      };

      function getShopifyLanguagePath(langKey, marketLanguages) {
        if (langKey !== 'zh-CN') {
          return shopifyURLs[langKey];
        }

        const hasTraditionalChinese = marketLanguages.includes('zh-TW');
        return hasTraditionalChinese ? '/zh-hans' : '/zh';
      }
    
      const repIDParam = !!url.searchParams.get('als') && url.searchParams.get('als') !== '1' ? `?als=${url.searchParams.get('als')}` : '';
    
      var languageData = {
        'en': { name: 'English', urlCode: 'en', href: URLs.en, shopifyValue: 'en', contentfulValue: 'en-US' },
        'zh-CN': { name: '简体中文', urlCode: 'zh-Hans', href: URLs.zh, shopifyValue: 'zh-CN', contentfulValue: 'zh-Hans-HK' },
        'zh-TW': { name: '繁體中文', urlCode: 'zh-Hant', href: URLs.zh_tw, shopifyValue: 'zh-TW', contentfulValue: 'zh-Hant-TW' },
        'es': { name: 'Español', urlCode: 'es', href: URLs.es, shopifyValue: 'es', contentfulValue: 'es-US'},
        'ja': { name: '日本語', urlCode: 'ja', href: URLs.ja, shopifyValue: 'ja', contentfulValue: 'ja-JP'},
        'ko': { name: '한국어', urlCode: 'ko', href: URLs.ko, contentfulValue: 'ko-KR' },
        'th': { name: 'Thai', urlCode: 'th', href: URLs.th, shopifyValue: 'th', contentfulValue: 'th-TH' },
      };
    
      function buildMarkets() {
        const marketDefs = [
          { name: 'USA', marketCode: 'us', defaultLanguage: 'en', languages: ['en','zh-CN','zh-TW','es']},
          { name: 'Canada', marketCode: 'ca', defaultLanguage: 'en', languages: ['en','zh-CN','zh-TW']},
          { name: 'Taiwan', marketCode: 'tw', defaultLanguage: 'zh-TW', languages: ['zh-TW']},
          { name: 'Hong Kong', marketCode: 'hk', defaultLanguage: 'zh-CN', languages: ['zh-CN','zh-TW','en']},
          { name: 'Australia', marketCode: 'au', defaultLanguage: 'en', languages: ['en','zh-CN']},
          { name: 'New Zealand', marketCode: 'nz', defaultLanguage: 'en', languages: ['en','zh-CN']},
          { name: 'Singapore', marketCode: 'sg', defaultLanguage: 'en', languages: ['en','zh-CN']},
          { name: 'Malaysia', marketCode: 'my', defaultLanguage: 'en', languages: ['en','zh-CN']},
          { name: 'Germany', marketCode: 'de', defaultLanguage: 'en', languages: ['en']},
          { name: 'Japan', marketCode: 'jp', defaultLanguage: 'ja', languages: ['ja','en']},
          { name: 'Netherlands', marketCode: 'nl', defaultLanguage: 'en', languages: ['en']},
          { name: 'Belgium', marketCode: 'be', defaultLanguage: 'en', languages: [  'en' ]},
          { name: 'United Kingdom', marketCode: 'gb', defaultLanguage: 'en', languages: ['en']},
          { name: 'Korea (the Republic of)', marketCode: 'kr', defaultLanguage: 'ko', languages: ['ko','en']},
          { name: 'Hong Kong Cross Market', marketCode: 'hkcm', defaultLanguage: 'zh-CN', languages: ['en','zh-CN']},
          { name: 'Thailand', marketCode: 'th', defaultLanguage: 'th', languages: ['th','en']},
        ];
      
        return marketDefs.map(def => {
          const langs = def.languages.map(langKey => {
            const hasShopifyValue = languageData[langKey].shopifyValue !== undefined;
            const fullLang = { ...languageData[langKey] };
            if (hasShopifyValue) {
              const basePath = langKey !== def.defaultLanguage ? getShopifyLanguagePath(langKey, def.languages) : '/';
              fullLang.shopifyHref = `${basePath}`;
            }
            return fullLang;
          });
      
          return {
            name: def.name,
            value: def.name,
            marketCode: def.marketCode,
            defaultLanguage: def.defaultLanguage,
            languages: langs
          };
        });
      }

      const markets = buildMarkets();
      
      var el = document.querySelector('[data-languages]');
      var availableLanguages = el.getAttribute('data-languages').split(',');
      var currentLanguage = el.getAttribute('data-current-language');
      var currentCountry = el.getAttribute('data-current-market');
      var currentShopUrl = el.getAttribute('data-store-url');
      if (currentShopUrl.endsWith('/')) {
        currentShopUrl = currentShopUrl.substring(0, currentShopUrl.length - 1);
      }
      
      var urlRoot = 'https://store.newulife.com/';
      
      // var addMarkets();
      var currentLanguageName = languageData[currentLanguage].name;
  
      var locale = languageData[currentLanguage].contentfulValue || 'en-US'; // Dynamically update this based on language from shopify
  
      var bydesignStoreHref = urlRoot;
      var currentMarketData = markets.find(market => market.name === currentCountry);
      var marketLanguages = currentMarketData.languages;
      var activeMarketLanguages = currentMarketData.languages;
      var marketDomain = 'https://newulife.com/'+ currentMarketData.marketCode + '/' + languageData[currentLanguage].urlCode;
      var socialLinks = [
        { href: 'https://www.facebook.com/newulife', imgSrc: 'https://newulife.com/images/facebook-social.svg', title: 'Facebook' },
        { href: 'https://www.linkedin.com/company/newulife', imgSrc: 'https://newulife.com/images/linkedin-social.svg', title: 'LinkedIn' },
        { href: 'https://www.instagram.com/newulife/', imgSrc: 'https://newulife.com/images/instagram.svg', title: 'Instagram' },
        { href: 'https://www.youtube.com/c/NewULife', imgSrc: 'https://newulife.com/images/youtube.svg', title: 'YouTube' },
        { href: 'https://vimeo.com/user82317897', imgSrc: 'https://newulife.com/images/vimeo.svg', title: 'Vimeo' },
        { href: 'https://twitter.com/realnewulife', imgSrc: 'https://newulife.com/images/twitter.svg', title: 'Twitter' },
        { href: 'https://in.pinterest.com/newulifeofficial/', imgSrc: 'https://newulife.com/images/pinterest.svg', title: 'Pinterest' },
      ];
      
      window.newULifeConfig = {
        bydesignStoreHref,
        currentMarketData,
        marketLanguages,
        activeMarketLanguages,
        locale,
        availableLanguages,
        currentLanguage,
        currentCountry,
        currentShopUrl,
        urlRoot,
        currentLanguageName,
        marketDomain,
        als: url.searchParams.get('als'),
        repIDParam,
        URLs,
        shopifyURLs,
        languageData,
        markets,
        socialLinks,
      };
  
      var configLoadedEvent = new CustomEvent('nulConfigLoaded', { detail: { message: 'newULifeConfig is loaded', config: window.newULifeConfig } });
      document.dispatchEvent(configLoadedEvent);
    });
  })();